import { render, staticRenderFns } from "./ShoppingCard.vue?vue&type=template&id=650aa9fb&scoped=true"
import script from "./ShoppingCard.vue?vue&type=script&lang=js"
export * from "./ShoppingCard.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCard.vue?vue&type=style&index=0&id=650aa9fb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650aa9fb",
  null
  
)

export default component.exports